module.exports = __webpack_public_path__ + "img/no-data-new.a317f907.png";